import { NgModule } from '@angular/core';
import { angularProvidersBuilder } from '@harmony/angular';
import { Functions } from 'firebase/functions';
import { FirebaseToken } from '../../app/core/firebase.module';
import { CommonProvider } from '../common/common.provider';
import { AuthGoogleDefaultProvider, AuthGoogleProvider } from './auth-google.provider';
import { LoginWithPopupGoogleAdapterInteractor } from './domain/login-with-popup-google-adapter.interactor';

@NgModule({
  providers: angularProvidersBuilder({
    provide: AuthGoogleProvider,
    deps: [CommonProvider, FirebaseToken.Functions],
    useFactory: (common: CommonProvider, functions: Functions) =>
      new AuthGoogleDefaultProvider(common, functions),
  })
    .add(LoginWithPopupGoogleAdapterInteractor, (p) => p.provideLoginWithPopupGoogleAdapter())
    .build(),
})
export class AuthGoogleProviderModule {}
